import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

const HandCoins = (props: SVGProps<any>): ReactElement => {
  return (
    <BaseIcon {...props}>
      <path
        d="M21.115 13.05a2.022 2.022 0 0 0-1.763-.351l-4.077.938a2.343 2.343 0 0 0-2.193-3.17H8.569a2.683 2.683 0 0 0-1.912.792l-2.093 2.093H1.903a1.262 1.262 0 0 0-1.262 1.262v3.606a1.262 1.262 0 0 0 1.263 1.262h9.375a.535.535 0 0 0 .131-.016l5.769-1.443a.661.661 0 0 0 .08-.027l3.499-1.489.03-.014a2.036 2.036 0 0 0 .327-3.441v-.002ZM1.723 18.219v-3.606a.18.18 0 0 1 .181-.18h2.344v3.966H1.903a.18.18 0 0 1-.18-.18Zm18.595-2.705-3.443 1.468-5.664 1.417H5.329v-4.283l2.093-2.093a1.612 1.612 0 0 1 1.147-.474h4.513a1.262 1.262 0 1 1 0 2.524h-2.525a.541.541 0 1 0 0 1.082h2.886a.538.538 0 0 0 .12-.014l6.04-1.389.022-.005a.954.954 0 0 1 .694 1.768Zm-5.073-6.85c.221 0 .44-.024.655-.071a3.065 3.065 0 1 0 2.296-3.824 3.065 3.065 0 1 0-2.951 3.895Zm5.588-.902a1.983 1.983 0 1 1-3.966 0 1.983 1.983 0 0 1 3.966 0Zm-5.588-4.146a1.978 1.978 0 0 1 1.938 1.577 3.065 3.065 0 0 0-1.386 2.312 1.984 1.984 0 1 1-.552-3.889Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};
export default HandCoins;
